import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@app/base/services';
import { environment } from '@environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (!environment.loginActivo) return next.handle(request);
        // Se agrega el token al header de la petición
        const { usuarioLogueadoData: usuario } = this.authenticationService;
        if (usuario && usuario.token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${usuario.token}`,
                },
            });
        }

        return next.handle(request);
    }
}
